/** @format */

import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "./assets.constants";

export const CONSTANTS_QUICK_ACTIONS = [
  {
    name: "WFO",
    id: "OFFICE",
    label: "Work From Office",
    icon: CONSTANTS_ASSETS_EMP_WEB_EXP.ICONS.QUICK_WFO,
    reqConfigs: ["createBookingEnabled"]
  },
  {
    name: "Remote",
    label: "Remote",
    id: "WFH",
    icon: CONSTANTS_ASSETS_EMP_WEB_EXP.ICONS.QUICK_WFH,
    reqConfigs: ["wfhBookingAllowed"]
    //reqConfigs: []
  }
];

export const CONSTANTS_QUICK_ACTIONS_PARKING = [
  {
    name: "WFO",
    id: "OFFICE",
    label: "Parking",
    icon: CONSTANTS_ASSETS_EMP_WEB_EXP.ICONS.PARKING_ACTION,
    reqConfigs: ["createBookingEnabled", "onlyParkingBookingEnabled"]
  },
  {
    name: "Remote",
    label: "Remote",
    id: "WFH",
    icon: CONSTANTS_ASSETS_EMP_WEB_EXP.ICONS.QUICK_WFH,
    reqConfigs: ["wfhBookingAllowed"]
    //reqConfigs: []
  }
];

export const WIDGET_LIST = [
  { name: `Today's booking`, type: "hero", reqConfigs: [], id: 0 },
  { name: `Team Calendar`, type: "calendar", reqConfigs: ["teamCalendarEnabled"], id: 1 },
  { name: `Upcoming bookings`, type: "list", actions: [{ name: "View more", id: 0 }], reqConfigs: [], id: 2, expanded: false },
  {
    name: `Meal Feedback`,
    type: "meal-list",
    reqConfigs: ["mealPlanningEnabled", "mealFeedbackEnabled"],
    actions: [{ name: "Rate More", id: 1}],
    id: 3,
    expanded: false
  },
  {
    name: `Today's Meetings`,
    type: "meeting-list",
    actions: [{ name: "View all", id: 1 }],
    reqConfigs: ["meetingRoomsWidgetEnabled"],
    id: 4,
    expanded: false
  }
];
